import React, { useState, useEffect } from "react";
import { GENERATETOKEN, MODULE_SKIP } from "../constants/constants";
import dataUser from "../constants/userData";
import { postData } from "../constants/Utils";
import base64 from "base-64";
import logo from "../assets/logo.png";

const Modules = (props) => {
  const [token, setToken] = useState("");
  const [modulos, setModulos] = useState([]);
  const [resultData, setResultData] = useState({});

  const validateToken = () => {
    var tokenDecoded = base64.decode(localStorage.getItem("franquicias"));
    if (
      tokenDecoded !== undefined &&
      tokenDecoded !== null &&
      tokenDecoded !== ""
    ) {
      setToken(tokenDecoded);
    }
  };

  useEffect(() => {
    setModulos(dataUser.modules);
    setResultData(dataUser);
    validateToken();
  }, []);

  const sendRedirect = (modul) => {
    console.log(modul);
    
    const mod = modul;
    if (mod.cmsCode === "" || mod.cmsCode === undefined) {
      if (mod.modulo.includes(MODULE_SKIP)) {
        window.location.href = mod.url + base64.encode(token);
      } else {
        const data = resultData;
        const splitLastName = data.user.lastName.split(" ");
        let requestToken = {
          franchiseName: data.franchise.name,
          franchiseStore: data.branchOffice.name,
          agentNameMember: data.user.name,
          agentLastName:
            splitLastName.length > 1 ? splitLastName[0] : data.user.lastName,
          agentMiddleName: splitLastName.length > 1 ? splitLastName[1] : " ",
          agentEpr: data.user.email,
          numberAccount: "",
          iat: "123",
          exp: "123",
          operation: mod.operation,
        };
        postData(GENERATETOKEN, requestToken).then((result) => {
          if (result !== null) {
            window.location.href = mod.url + result.token;
          }
        });
      }
    } else {
      props.redirectTo("Member Authentication", modul, resultData);
    }
  };

  const redirectTo = () => {
    props.redirectTo("Login");
  };

  return (
    <div className="container">
      <div className="row justify-content-center signup-form">
        <div className=" col-12 col-md-9 col-lg-6 pt-20">
          <div className="card signup-card">
            <div className="card-head text-center px-15 p-md-15 bg-dark">
              <div className="cp-logo pt-15">
                <img alt="ClubPremier" width="80%" src={logo} />
              </div>
            </div>
            <div className="card-body px-15 p-md-30 ">
              <div className="row justify-content-center">
                <div className="col-11 col-md-11 pt-11 text-center">
                  <h2 className=" mb-20">Módulos</h2>
                </div>

                {modulos.length > 0 ? (
                  modulos.map((moduleUser) => {
                    return (
                      <div key={moduleUser.modulo} className="col-11 p-10">
                        <button
                          key={moduleUser.modulo}
                          className="col-12 btn btn-color-blue  p-10"
                          onClick={() => sendRedirect(moduleUser)}
                        >
                          <b>{moduleUser.modulo}</b>
                        </button>
                      </div>
                    );
                  })
                ) : (
                  <h2>
                    <b>
                      "No hay ningún modulo asignado a este usuario, contacte al
                      administrador"
                    </b>
                  </h2>
                )}

                <div className="col-8 pt-30 ">
                  <div className="text-center pt-15">
                    <span className="btn btn-link" onClick={redirectTo}>
                      Salir
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modules;



// WEBPACK FOOTER //
// ./src/components/Modules.js